import React, { useState } from "react";
import MapConfig from "services/map/MapConfig";
import styled from "@emotion/styled";

import HoursSlider from "components/HoursSlider";
import DaysSlider from "components/DaysSlider";

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const DaysSliderContainer = styled.div`
  margin-bottom: 10px;
`;

type Props = {
  maxDaysAllowed: number;
  onTimestampChange: Function;
  selectedTimestamp: number;
};

function DaysHoursSlider({
  maxDaysAllowed,
  onTimestampChange,
  selectedTimestamp,
}: Props): JSX.Element {
  const [disabled, setDisabled] = useState(false);

  // Use a tempo to disable pickers during retrieval
  // Unable to fix this bug properly (faster to do this way)
  // https://parkki.atlassian.net/browse/CLT-26
  function temporize(ms = MapConfig.timePickers.tempo) {
    setDisabled(true);
    setTimeout(() => setDisabled(false), ms);
  }

  function handleTimeChange(timestamp: number) {
    temporize();
    onTimestampChange(timestamp);
  }

  function handleDayChange(timestamp: number) {
    temporize();
    onTimestampChange(timestamp);
  }

  return (
    <Container>
      <DaysSliderContainer>
        <DaysSlider
          disabled={disabled}
          selectedTimestamp={selectedTimestamp}
          maxDaysAllowed={maxDaysAllowed}
          onDaysSelected={handleDayChange}
        />
      </DaysSliderContainer>

      <HoursSlider
        disabled={disabled}
        selectedTimestamp={selectedTimestamp}
        onHoursSelected={handleTimeChange}
      />
    </Container>
  );
}

DaysHoursSlider.defaultProps = {
  selectedTimestamp: 0,
};
export default DaysHoursSlider;
